import { render, staticRenderFns } from "./ModalCancelarConta.vue?vue&type=template&id=a5c230ae&"
import script from "./ModalCancelarConta.vue?vue&type=script&lang=js&"
export * from "./ModalCancelarConta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports